import $ from "jquery";

let csrfSafeMethod;

let getCookie;
let runSetup;

getCookie = require("./get_cookie").default;

csrfSafeMethod = method => /^(GET|HEAD|OPTIONS|TRACE)$/.test(method);

runSetup = () => {
	let csrfToken;
	csrfToken = getCookie(window.csrfCookieName);
	return $.ajaxSetup({
		beforeSend(xhr, { type }) {
			if (!csrfSafeMethod(type) && !this.crossDomain) {
				return xhr.setRequestHeader("X-CSRFToken", csrfToken);
			}
		}
	});
};

export default runSetup;
